module.exports = __webpack_public_path__ + "img/messageIcon_Active.81dc86d6.png";